import { Link } from 'react-router-dom';

// LCP images MUST be in public folder with exact path matching preload in index.html
// This ensures browser discovers them from initial HTML document
const heroDtf = '/images/hero-dtf.webp';
const heroDtfUv = '/images/hero-dtf-uv.webp';

interface HeroCardProps {
  image: string;
  alt: string;
  link: string;
  isLCP?: boolean;
}

const HeroCard = ({ image, alt, link, isLCP = false }: HeroCardProps) => {
  return (
    <Link 
      to={link}
      className="relative group overflow-hidden rounded-lg aspect-square flex items-center justify-center"
    >
      <img 
        src={image} 
        alt={alt}
        fetchPriority={isLCP ? "high" : undefined}
        loading={isLCP ? "eager" : "lazy"}
        decoding={isLCP ? "sync" : "async"}
        width={608}
        height={608}
        className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
      />
    </Link>
  );
};

export const HeroSection = () => {
  return (
    <section className="bg-primary py-8 px-4">
      <div className="container mx-auto">
        <div className="grid md:grid-cols-2 gap-6">
          <HeroCard 
            image={heroDtf}
            alt="Stampa DTF"
            link="/stampa-dtf"
            isLCP={true}
          />
          <HeroCard 
            image={heroDtfUv}
            alt="Stampa DTF UV"
            link="/stampa-dtf-uv"
            isLCP={true}
          />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
